import React from 'react';
import Container from 'components/Container';
import Image from 'components/Image';
import Text from 'components/Text';
import CoachingHeading from 'coaching/components/CoachingHeading';
import circlePointer from 'assets/images/coaching/circle_pointer.svg';

import 'coaching/components/styles/CoachingCoachHelpHomeIntro.scss';

export default function CoachingCoachHelpHomeIntro() {
  return (
    <Container align="center" size="small" className="CoachingCoachHelpHomeIntro-wrapper">
      <CoachingHeading size="xsmall" textSize="xxxxlarge" centerText>
        We're here for you
      </CoachingHeading>
      <Text size="medium" color="graphite" align="center">
        We’re here to resolve any issues you’re experiencing so you can continue supporting your
        students.
      </Text>
      <Image src={circlePointer} className="CoachingCoachHelpHomeIntro-illustration" />
    </Container>
  );
}
